<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <b-card-header>
      <b-card-title class="section-title">
        {{ $t('Favourites') }}
      </b-card-title>
    </b-card-header>

    <ul class="bulletin-list">
      <li
        v-for="(favorite, index) in favorites"
        :key="index"
      >
        <feather-icon
          size="20"
          :icon="favorite.icon"
        />
        <router-link
          class="favorite-links"
          :to="{ name: favorite.route }"
        >
          {{ $t(favorite.name) }}
        </router-link>
        <small class="text-muted ml-auto">{{ favorite.count }} {{ favorite.count > 1 ? $t('visits') : $t('visit') }}</small>
      </li>
      <li
        v-if="favorites.length === 0"
        class="no-favorites"
      >
        {{ $t('No favorites yet. Start using the app to build your favorites list.') }}
      </li>
    </ul>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardTitle } from 'bootstrap-vue'
import FavoriteService from '../../../helpers/favoriteService'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
  },
  data() {
    return {
      favorites: [],
    }
  },
  created() {
    // Load initial favorites
    this.loadFavorites()
  },
  methods: {
    loadFavorites() {
      this.favorites = FavoriteService.getFavorites()
    },
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
.bulletin-list {
  list-style: none;
  padding: 10px 0;
  margin: 0;
}

.bulletin-list li {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.favorite-links{
  margin: 0 1rem;
  font-size: 1.1rem;
}
.section-title{
  font-weight: 800;
}
.no-favorites {
  color: #757575;
  font-style: italic;
}
</style>
